import ComponentRegistry from '@lts-web/registry/ComponentRegistry';

export const registerLazyComponent = (selector, classLoader, props, context) => {
    registerComponent(selector, {
        loader: (connectComponent, node, props, context) => {
            classLoader()
                .then(module => {
                    connectComponent(module.default, node, props, context);
                })
        }
    }, props || {}, context, true);
};

export const connectLazyComponent = (node, props, context, loader, expandClassFn) => {
    return (
        loader().then(module => {
            ComponentRegistry.connectComponent(
                expandClassFn(module.default),
                node,
                props,
                context
            )
        })
    );
};

export const registerComponent = (selector, ctor, props, context, lazy) => {
    return ComponentRegistry.getInstance().registerComponent(selector, ctor, props, context, lazy);
};

export const observeComponents = (node, config) =>  {
    return ComponentRegistry.getInstance().observeMutations(node, config);
};

export const isComponentRegistered = (selector) => {
    return ComponentRegistry.getInstance().getRegistry().hasOwnProperty(selector);
};

export const forceComponentConnection = (element) => {
    const componentName = element.dataset.component;
    const componentSelector = composeComponentSelector(componentName);
    const componentRegistry = ComponentRegistry.getInstance();
    const connectComponentsFn = ComponentRegistry.connectComponents;

    if (!isComponentRegistered(componentSelector)) {
        return false;
    }

    connectComponentsFn([element], componentRegistry.getRegistry());
    return true;
};

export const composeComponentSelector = name => name ? `[data-component="${name}"]` : `[data-component]`;